import { render, staticRenderFns } from "./Trash-Can.vue?vue&type=template&id=7de793f1&"
import script from "./Trash-Can.vue?vue&type=script&lang=js&"
export * from "./Trash-Can.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports